import { useEffect, useState } from "react";
import "./calendar.scss";
import CalendarTemplate from "componets/templates/calendarTemplate/calendarTemplate";
import axios from "axios";
import { baseURL } from "utilities/variables";
const Calendar = () => {
  const [calendarData, setCalendarData] = useState(undefined);

  useEffect(() => {
    axios
      .get(
        baseURL +
          "/api/calendario?populate=encabezado%2C%20actividades.tipoResponsables&populate=encabezado.imagenPrincipal.imagen"
      )
      .then((response) => {
        //Darle un formato más sencillo a los datos:
        let auxData = response.data.data.attributes;
        let auxEasyData = {};
        auxEasyData.encabezado = auxData.encabezado;
        auxEasyData.descripcionFinal = auxData.descripcionFinal;
        auxEasyData.actividades = auxData.actividades;
        auxEasyData.image = `${baseURL}${auxData.encabezado.imagenPrincipal.imagen.data.attributes.url}`;
        auxEasyData.imageAlt =
          auxData.encabezado.imagenPrincipal.imagen.data.attributes.alternativeText;

        setCalendarData(auxEasyData);
      });
  }, []);

  return (
    <>
      {calendarData !== undefined && <CalendarTemplate data={calendarData} />}
    </>
  );
};
export default Calendar;
